const config = {
    PORT: process.env.REACT_APP_BACKEND_PORT || 3000,
    BACKEND: process.env.REACT_APP_BACKEND || "localhost",
    GRUPOS:{
    0: "Otros",
    1: "Pizarrales",
    2: "Amis",
    3: "Tierra charra",
    4: "María Auxiliadora",
    5: "Juan de la Fuente",
    6: "Trastormes",
    7: "Buenos Aires",
    8: "Tejares",
    9: "Chamberí",
    10: "San Isidro",
    11: "Puente Ladrillo",
    12: "La Vega",
    13: "San José",
    14: "Vidal",
  }
};

// URL base de la API.
// En producción se define REACT_APP_API_BASE_URL (p.ej. https://prege.fis.usal.es/api)
// para pasar por el reverse-proxy de nginx en el 443 y evitar el puerto 3000, que el
// firewall perimetral bloquea desde fuera de la red. En desarrollo, si no está definida,
// se usa el host:puerto directo de siempre (https://localhost:3000).
const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL || `https://${config.BACKEND}:${config.PORT}`;
config.API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, '');

module.exports = config;
